import React, { useCallback, useMemo } from 'react';
import clsx from 'clsx';

import CommonMenuItem from './CommonMenuItem';
import CommonMenuSubmenu from './CommonMenuSubmenu';

import './CommonMenu.scss';

export const MENU_ITEM_TYPES = {
  LABEL: 'label',
  SUBMENU: 'submenu',
};

const CommonMenu = ({ options, onSelect }) => {
  const handleSelect = useCallback(
    (selectedValue) => {
      onSelect(selectedValue);
    },
    [onSelect],
  );

  const isContainSubmenu = useMemo(() => options.some(({ type }) => type === MENU_ITEM_TYPES.SUBMENU), [options]);

  const mappedMenuItems = useMemo(
    () =>
      options.map(({ type = MENU_ITEM_TYPES.LABEL, ...itemProps }) => {
        switch (type) {
          case MENU_ITEM_TYPES.LABEL:
            return {
              value: itemProps.value,
              component: () => <CommonMenuItem {...itemProps} onSelect={handleSelect} />,
            };

          case MENU_ITEM_TYPES.SUBMENU:
            return {
              value: itemProps.value,
              component: () => <CommonMenuSubmenu {...itemProps} />,
            };
        }
      }),
    [options, handleSelect],
  );

  return (
    <div className={clsx('common-menu', isContainSubmenu ? 'common-menu--with-submenu' : 'common-menu--no-submenu')}>
      <ul className='common-menu_options'>
        {mappedMenuItems.map(({ value, component: Component }) => (
          <Component key={value} />
        ))}
      </ul>
    </div>
  );
};

export default CommonMenu;
